// 貼文、留言 檢舉彈窗
import { useRef, useEffect } from 'react';
import { setHintText, setShowHintModal } from '@/slices/popSlice';
import newsClient from '@/common/apiClient/newsClient';
import { REPORT_RULES } from '@/common/constant'; // 檢舉理由

const ReportModal = ({ t, dispatch, showReportModal, setShowReportModal }) => {
    const textareaRef = useRef(null);

    // 檢舉理由
    const { rule = 'violent', reason = '' } = showReportModal;

    const onChange = (key, value) =>
        dispatch(setShowReportModal({ ...showReportModal, [key]: value }));

    // 取消
    const onCancel = () => dispatch(setShowReportModal(false));

    // 送出檢舉
    const onSubmit = async () => {
        try {
            const { status } = await newsClient.report(showReportModal);
            if (status === 'success') {
                onCancel();
                dispatch(setHintText('REPORT'));
                dispatch(setShowHintModal(true));
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        const textarea = textareaRef.current;
        if (textarea) {
            if (reason === '') {
                textarea.style.height = '59px'; // 原始高度
            } else {
                textarea.style.height = 'auto'; // 重設再計算
                textarea.style.height = `${textarea.scrollHeight}px`;
            }
        }
    }, [reason]);

    return (
        <div className="modal">
            <div className="bg-white rounded-[22px] p-[30px] w-[400px]">
                <p className="text-h6 text-jblack">{t('REPORT_SELECT')}</p>

                <div className="space-y-[22px] mt-[22px] mb-[30px]">
                    {/* 檢舉選項 */}
                    {REPORT_RULES.map((r, index) => {
                        const isRule = r === rule;
                        return (
                            <button
                                key={'report-rule' + index}
                                onClick={() => onChange('rule', r)}
                                className="flex gap-x-[12px] text-btn4 text-black items-center"
                            >
                                <span
                                    className={`w-[16px] h-[16px] flex-shrink-0 rounded-[50%] border-1 center-center
                                    ${isRule ? 'border-vPurple' : 'border-purple6'}`}
                                >
                                    <span
                                        className={`rounded-[50%] w-[10px] h-[10px] ${
                                            isRule ? 'bg-vPurple' : ''
                                        }`}
                                    />
                                </span>
                                {t(`RULE_${r?.toUpperCase()}`)}
                            </button>
                        );
                    })}

                    {/* 檢舉理由 */}
                    <textarea
                        ref={textareaRef}
                        rows={1}
                        maxLength={50}
                        className="border-1 border-black4 border-opacity-[.1] bg-opacity-[.1] bg-black2 rounded-[12px] placeholder:text-black3 text-btn1 text-black8
                        dark:border-opacity-[0.09] w-full resize-none p-[20px] outline-none dark:placeholder:text-black5 noScrollY min-h-[59px]"
                        placeholder={t('REPORT_PLACEHOLDER')}
                        value={reason}
                        onChange={(e) => onChange('reason', e.target.value)}
                    />
                </div>

                <div className="between-center">
                    {/* 取消 */}
                    <button onClick={onCancel} className="cancel-btn dark:hover:text-[#fff]">
                        {t('CANCEL')}
                    </button>

                    {/* 確認 */}
                    <button className="confirm-btn" onClick={onSubmit}>
                        {t('SEND')}
                    </button>
                </div>
            </div>

            {/* 關閉用背景 */}
            <div className="close-bg" onClick={onCancel} />
        </div>
    );
};

export default ReportModal;
